import {
  ModuleId,
  PageComponentId,
  TModuleParams,
} from '@wix/business-manager-api';

export const MODULE_ID = ModuleId.VideoMakerHome;
export const COMPONENT_NAME = PageComponentId.VideoMakerHome;

export interface IERBConfig {
  topology: {
    staticsUrl: string;
  };
}

export interface IBMModuleParams extends TModuleParams {
  locale: string;
  config: IERBConfig;
}
